<bn-web-ui-card
  data-e2e="UploadScanningCard"
  heading="Upload Scanning"
  inputType="switch"
  [inputValue]="isEnabled?.()"
  [isLoading]="isUpdating.enabled()"
  (valueChanged)="onUploadScaningChange($event)">
  <p class="bn-shield-us__heading-card__text">
    Bunny Shield Upload Scanning proactively inspects file uploads in real time, blocking harmful or illegal content before it reaches your origin. Safeguard
    your applications by filtering out malware, viruses, and CSAM, ensuring that only safe and compliant files are delivered to your servers.
  </p>
  <div class="bn-shield-us__heading-card__img">
    <img src="/assets/web-ui/images/bunny-silas.svg" />
  </div>
</bn-web-ui-card>
<div>
  <div class="bn-shield-us__table__header">Scanning Filters</div>
  @let isAdvanced = (selectedShield()?.planType ?? planType.Basic) > planType.Basic;
  <div
    class="bn-shield-us__table__row"
    [tooltip]="!isAdvanced ? upgradeAdvancedTooltip : undefined">
    <div class="d-flex">
      <span class="d-flex flex-grow-1 pe-4 align-items-center align-items-xl-initial">
        <bn-web-ui-switch
          size="sm"
          [disabled]="isLoading() || isUpdating.antivirus() || !isAdvanced"
          [loading]="isLoading() || isUpdating.antivirus()"
          [ngModel]="antivirusSwitch()"
          (ngModelChange)="onSwitchClick($event, 'antivirusScanningMode')"
          ><span
            class="ms-1 text-dark-8 text-200-semi-bold"
            label-after
            >Antivirus
            <bn-web-ui-badge
              color="premium"
              contentClass="ms-2"
              >Advanced</bn-web-ui-badge
            ></span
          ></bn-web-ui-switch
        >
      </span>
      <div>
        <ng-select
          class="bn-shield-us__table__row__select ng-select-xs"
          [bindLabel]="'Name'"
          [bindValue]="'Id'"
          [clearable]="false"
          [disabled]="isLoading() || isUpdating.antivirusSelect() || !isAdvanced || !antivirusSwitch()"
          [items]="availableActions"
          [loading]="isLoading() || isUpdating.antivirusSelect()"
          [ngModel]="antivirusSelect()"
          [searchable]="false"
          (change)="onActionSelect($event?.Id, 'antivirusScanningMode')">
          <ng-template
            let-item="item"
            ng-label-tmp>
            <span class="d-flex align-items-center">
              <ng-container
                [ngTemplateOutlet]="selectIcons"
                [ngTemplateOutletContext]="{ $implicit: item?.Id }" />
              <span>{{ item?.Name }}</span>
            </span>
          </ng-template>
          <!-- Options template -->
          <ng-template
            let-item="item"
            ng-option-tmp>
            <span class="d-flex align-items-center">
              <ng-container
                [ngTemplateOutlet]="selectIcons"
                [ngTemplateOutletContext]="{ $implicit: item?.Id }" />
              <span>{{ item?.Name }}</span>
            </span>
          </ng-template>
        </ng-select>
      </div>
    </div>
    <div>
      <p
        class="mb-0 mt-2 mt-xxl-0"
        [ngClass]="{ 'opacity-50': !isAdvanced }">
        Identifies malicious files such as viruses, trojans, ransomware, and other forms of malware within uploaded content.
      </p>
    </div>
  </div>
  <div class="bn-shield-us__table__row">
    <div class="d-flex">
      <span class="d-flex flex-grow-1 pe-4 align-items-center align-items-xl-initial">
        <bn-web-ui-switch
          size="sm"
          [disabled]="isLoading() || isUpdating.csam()"
          [loading]="isLoading() || isUpdating.csam()"
          [ngModel]="csamSwitch()"
          (ngModelChange)="onSwitchClick($event, 'csamScanningMode')"
          ><span
            class="ms-1 text-dark-8 text-200-semi-bold"
            label-after
            >CSAM</span
          ></bn-web-ui-switch
        >
      </span>
      <div>
        <ng-select
          class="bn-shield-us__table__row__select ng-select-xs"
          [bindLabel]="'Name'"
          [bindValue]="'Id'"
          [clearable]="false"
          [disabled]="isLoading() || isUpdating.csamSelect() || !csamSwitch()"
          [items]="availableActions"
          [loading]="isLoading() || isUpdating.csamSelect()"
          [ngModel]="csamSelect()"
          [searchable]="false"
          (change)="onActionSelect($event?.Id, 'csamScanningMode')">
          <ng-template
            let-item="item"
            ng-label-tmp>
            <span class="d-flex align-items-center">
              <ng-container
                [ngTemplateOutlet]="selectIcons"
                [ngTemplateOutletContext]="{ $implicit: item?.Id }" />
              <span>{{ item?.Name }}</span>
            </span>
          </ng-template>
          <!-- Options template -->
          <ng-template
            let-item="item"
            ng-option-tmp>
            <span class="d-flex align-items-center">
              <ng-container
                [ngTemplateOutlet]="selectIcons"
                [ngTemplateOutletContext]="{ $implicit: item?.Id }" />
              <span>{{ item?.Name }}</span>
            </span>
          </ng-template>
        </ng-select>
      </div>
    </div>
    <div>
      <p class="mb-0 mt-2 mt-xxl-0">
        Detects Child Sexual Abuse Material using advanced recognition technology to ensure compliance with safety and legal standards.
      </p>
    </div>
  </div>
</div>

<bn-web-ui-card
  class="my-2"
  [noPadding]="true">
  <div class="row g-0">
    <div class="col-4 border-right border-dark-2 p-4">
      <p class="text-200-regular text-bunny-dark mb-1">Total files scanned</p>
      <p class="text-700-regular text-bunny-dark">{{ (totalFilesScanned() | metricFormat).formatted }}</p>
    </div>
    <div class="col-4 border-right border-dark-2 p-4">
      <p class="text-200-regular text-bunny-dark mb-1">Total logged requests</p>
      <p class="text-700-regular text-bunny-dark">{{ (loggedRequests() | metricFormat).formatted }}</p>
    </div>
    <div class="col-4 border-dark-2 p-4">
      <p class="text-200-regular text-bunny-dark mb-1">Total blocked requests</p>
      <p class="text-700-regular text-bunny-dark">{{ (blockedRequests() | metricFormat).formatted }}</p>
    </div>
  </div>
</bn-web-ui-card>

<div class="my-2">
  <bn-web-ui-card heading="Scanning activity">
    <div class="chart-container position-relative">
      <bn-chart-multi-metric
        [chartConfig]="{
          formatMode: 'metricSymbol',
          summaryLabels: [
            { key: 'totalFilesScanned', label: 'Files scanned', color: 'info' },
            { key: 'totalBlockedRequests', label: 'Blocked requests', color: 'success' },
            { key: 'totalLoggedRequests', label: 'Logged requests', color: 'warning' },
          ],
        }"
        [data]="uploadScanningChart().chartSeries"
        [summaryLabels]="uploadScanningChart().total" />
      @if (!uploadScanningChartHasData()) {
        <div class="chart-overlay">
          <span>There is no scanning data to show yet.</span>
        </div>
      }
    </div>
  </bn-web-ui-card>
</div>

<ng-template
  #selectIcons
  let-id>
  @switch (id) {
    @case (uploadScanningAction.Log) {
      <fa-icon
        class="me-2"
        icon="file-lines" />
    }
    @case (uploadScanningAction.Block) {
      <fa-icon
        class="me-2"
        icon="ban" />
    }
    @default {
      <fa-icon
        class="me-2"
        icon="circle" />
    }
  }
</ng-template>

<ng-template #upgradeAdvancedTooltip>Upgrade to Advanced plan<br />to use this feature.</ng-template>
